<template>
  <FranchiseClinicProductsList />
</template>

<script>
import FranchiseClinicProductsList from '@/views/components/FranchiseClinicCustomProductsList';

export default {
  name: 'FranchiseProductsList',
  components: {
    FranchiseClinicProductsList,
  },
};
</script>
